// QA/Sandbox-only shortcut (Asana 1219649902198445): for a few named test
// users the orientation video completes after a few seconds of real playback
// instead of 80% of a ~13 minute video, so QA can rerun the orientation flow
// quickly.
//
// Who is a test user is decided server-side: /my-case answers
// data.fast_orientation_seconds only for the signed-in learner when they are
// on the backend's FAST_ORIENTATION_TEST_IDS list (never in production). The
// list itself never ships in this bundle. The reporting Lambda and the
// video-status webhook use the same list for the CRM flag and the OR
// milestone, so the badge, the Home unlock and the CRM all flip together.

let fastSeconds = null;

// Set from the signed-in learner's /my-case answer (useOrientationLock, which
// App renders before any child), so every isCompleted caller -- cards, modal,
// Home, dashboards -- sees the same answer without threading it through each.
export const setFastOrientationSeconds = (value) => {
  const seconds = Number(value);
  fastSeconds = Number.isFinite(seconds) && seconds > 0 ? seconds : null;
};

/** Seconds that complete orientation for the signed-in learner, or null. */
export const fastOrientationSeconds = () => fastSeconds;

// Seconds to credit when a test user taps Play on an orientation video, or
// null for everyone else. CI's headless browser gets YouTube's "confirm you're
// not a bot" wall, so the video never actually plays and no progress tick ever
// fires; crediting the shortcut's seconds on the tap lets the same saved
// progress complete the badge, the Home unlock and (via the reporting Lambda)
// the CRM flag and OR milestone. Capped at 80% of the video, the normal rule.
export const fastOrientationTapSeconds = (videoLength) => {
  if (!fastSeconds) return null;
  const length = Number(videoLength);
  return Number.isFinite(length) && length > 0
    ? Math.min(fastSeconds, length * 0.8)
    : fastSeconds;
};
